module.exports = __webpack_public_path__ + "static/img/login-logo.5e8d377c.png";